import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../features/auth/hooks/useAuth";
import { EVENTS_ROUTE, LANDING_ROUTE } from "../routes";

const RootRedirect: React.FC = () => {
  const { isAuthenticated, authInitialized } = useAuth();
  const location = useLocation();

  if (!authInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Caricamento...</p>
        </div>
      </div>
    );
  }

  const target = (isAuthenticated ? EVENTS_ROUTE : LANDING_ROUTE) + location.search;
  return <Navigate to={target} replace />;
};

export default RootRedirect;
